module.exports = __webpack_public_path__ + "static/media/need-and-expectation.db5532e8.svg";